<ng-container
  *ngIf="{
    channel: channel$ | async,
    channelStr: channelStr$ | async,
    active: active$ | async,
    hasSkillActive: hasSkillActive$ | async,
    canActive: canActive$ | async,
    dirty: dirty$ | async,
    hasSkillDirty: hasSkillDirty$ | async,
    underInstruction: underInstruction$ | async,
    index: index$ | async,
    push: push$ | async,
    isMail: isMail$ | async
  } as data"
>
  <td colspan="97" class="title">
    <span class="nodisplay">{{ 'commons:basic.channel' | translate }}</span>
    {{ 'commons:basic.channels.' + data.channelStr | translate }}
    <span *ngIf="!data.active && data.hasSkillActive"> - {{ 'commons:basic.planning.unactive_label' | translate }} </span>
    <!-- Mail case -->
    <ng-container *cngHasPermission="'CSR_MAIL_INCOMING::self:mail_push'">
      <span id="pushActivationButton" *ngIf="data.isMail" [hidden]="!data.canActive">
        <label *ngIf="data.push" for="mailPushActivation">{{ 'agent:general_information.mail_push_enabled' | translate }}</label>
        <label *ngIf="!data.push" for="mailPushActivation">{{ 'agent:general_information.mail_push_disabled' | translate }}</label>
        <input
          id="mailPushActivation"
          type="checkbox"
          class="checkAll"
          [ngModel]="data.push"
          (change)="toogleMailPushActivation(!data.push)"
        />
      </span>
    </ng-container>
  </td>

  <td class="action">
    <label for="channelPlanning{{ data.index }}" class="nodisplay">
      {{ 'agent:general_information.channel_activation' | translate }}
      {{ 'commons:basic.channels.' + data.channelStr | translate }}
    </label>
    <mat-slide-toggle
      [id]="'channelPlanning' + data.index"
      [checked]="data.hasSkillActive"
      [disabled]="data.hasSkillDirty || data.underInstruction"
      *ngIf="data.canActive"
      (toggleChange)="toogleSkillsActivation(!data.hasSkillActive)"
    >
    </mat-slide-toggle>
  </td>
</ng-container>
